import "./styles.scss";

export interface CFDIMoreDetailsLabelProps {
  onClick: () => void
}

const CFDIMoreDetailsLabel = (props: CFDIMoreDetailsLabelProps) => {
  const { onClick } = props;
  return(
    <div 
      className="cfdi-more-details-label"
      onClick={onClick}
    >
      <span>Ver detalles</span>
    </div>
  )
}

export default CFDIMoreDetailsLabel;